import React from 'react';

import { Box } from '@mui/material';
import TextFieldCDS from '@sharedCR/coreDesignSystem/form/TextFieldCDS';
import AutocompleteCDS from 'app/shared/componentsRestyled/coreDesignSystem/form/AutocompleteCDS/AutocompleteCDS';
import PropTypes from 'prop-types';

import { VendorRequestsTestIds } from '../../vendorRequests.testIds';
import { VENDOR_REQUEST_STATUS_OPTIONS } from '../../VendorRequestsFilters/VendorRequestsFilters.constants';
import {
  itemsFilterFieldStyles,
  itemsFiltersWrapperStyles,
} from '../VendorRequestDetailDrawer.styles';

const VendorRequestItemsFilters = ({
  operationType,
  statuses,
  vendorRequestId,
  onOperationTypeChange,
  onStatusesChange,
  onVendorRequestIdChange,
}) => (
  <Box sx={itemsFiltersWrapperStyles}>
    <Box sx={itemsFilterFieldStyles}>
      <TextFieldCDS
        dataTestId={VendorRequestsTestIds.ITEMS_OPERATION_INPUT}
        label="Operation"
        name="itemOperationType"
        value={operationType}
        onChange={onOperationTypeChange}
      />
    </Box>
    <Box sx={itemsFilterFieldStyles}>
      <AutocompleteCDS
        multiple
        dataTestId={VendorRequestsTestIds.ITEMS_STATUS_SELECT}
        label="Status"
        name="itemStatuses"
        optionKey="id"
        optionName="name"
        options={VENDOR_REQUEST_STATUS_OPTIONS}
        value={statuses}
        onChange={onStatusesChange}
      />
    </Box>
    <Box sx={itemsFilterFieldStyles}>
      <TextFieldCDS
        dataTestId={VendorRequestsTestIds.ITEMS_VENDOR_REQUEST_ID_INPUT}
        label="Vendor Request ID"
        name="itemVendorRequestId"
        value={vendorRequestId}
        onChange={onVendorRequestIdChange}
      />
    </Box>
  </Box>
);

VendorRequestItemsFilters.propTypes = {
  operationType: PropTypes.string.isRequired,
  statuses: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    }),
  ).isRequired,
  vendorRequestId: PropTypes.string.isRequired,
  onOperationTypeChange: PropTypes.func.isRequired,
  onStatusesChange: PropTypes.func.isRequired,
  onVendorRequestIdChange: PropTypes.func.isRequired,
};

export default VendorRequestItemsFilters;
